// Countries and cities are always listed in alphabetical order, in the page's language
// (decided 2026-11-02). Sorted here, not in the API: other applications read the same
// endpoints and rely on the order they answer in.

import i18next from "i18next";

// i18n's languages as Intl locale tags: "en_uk" isn't one (Intl throws on the underscore).
export const intlLocale = (language: string = i18next.language || "en"): string =>
  (language || "en").replace(/^en_uk$/i, "en-GB").replace(/_/g, "-");

// A copy of the items, by name: case and accents don't split letters ("Équateur" sorts with
// the E's), and numbers sort by value.
export const alphabetical = <T>(items: T[], name: (item: T) => string, language?: string): T[] => {
  let collator: Intl.Collator;
  try {
    collator = new Intl.Collator([intlLocale(language), "en"], { sensitivity: "base", numeric: true });
  } catch (e) {
    collator = new Intl.Collator("en", { sensitivity: "base", numeric: true });
  }
  return items.slice().sort((a, b) => collator.compare(name(a) || "", name(b) || ""));
};
